import WithRender from "../../templates/imageEditor/steckdosen.html";
import { mapGetters } from "vuex";

export default WithRender({
  props: ["index"],
  data: function () {
    return {
      show: 0
    };
  },
  computed: {
    ...mapGetters(["getSteckdosen", "getPOIEVariables", "getDefaultSockets"]),
    total: function () {
      return this.getSteckdosen.dosens.length;
    },
    getSockets: function () {
      return this.getDefaultSockets;
    },
    enableSteckdosen: function () {
      return parseFloat(this.getPOIEVariables.enableSteckdosen);
    }
  },
  methods: {
    onEnter: function (event) {
      event.preventDefault();
    },
    addDosen: function (type, e) {
      this.$store.commit("addNewDosen", {
        type: type
      });
    },
    showEmpty: function (level) {
      return this.total + level <= 6 && this.total;
    },
    hoverItem: function (index) {
      $("li.newdosen_item").removeClass("hover");
      $("li#steckdosen-item-" + index).addClass("hover");
    },
    removeHover: function () {
      $("li.newdosen_item").removeClass("hover");
    },
    removeSteckDosen: function (index) {
      var POIEVariables = this.getPOIEVariables;
      if (confirm(POIEVariables.Texts.steckdosen.remove)) {
        this.$store.commit("removeDosen", index);
      }
    }
  },
  mounted: function () {
    jQuery(".steckdosen_item").draggable({
      appendTo: "body",
      revert: "invalid",
      helper: function () {
        var _self = $(this);
        var data = _self.data();
        var info = data.info;
        return jQuery("<div>")
          .addClass("steckdosen_item_placeholder ")
          .css({
            "background-image": "url(" + info.image_url + ")",
            "background-size": "contain",
            width: _self.width(),
            height: _self.height(),
            "background-repeat": "no-repeat",
            "background-position": "center center",
            "z-index": "9999"
          });
      },
      drag: function (event, ui) {},
      start: (function () {
        return function (event, ui) {};
      })(),
      cursor: "move"
    });
  }
});
